import { render, staticRenderFns } from "./AssignedActivityList.vue?vue&type=template&id=022d68ca&scoped=true&"
import script from "./AssignedActivityList.vue?vue&type=script&lang=js&"
export * from "./AssignedActivityList.vue?vue&type=script&lang=js&"
import style0 from "./AssignedActivityList.vue?vue&type=style&index=0&id=022d68ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022d68ca",
  null
  
)

export default component.exports